import React from 'react';
import { Col } from 'reactstrap';
import NewCameraCount from './Cards/NewCameraCount';
import NewAIAccuracy from './Cards/NewAIAccuracy';
import HighestOrHighSeverity from './Cards/highestOrHighSeverity';

const HeroSection = ({
    connectivityFactoryLoader,
    factoryCamerasCount,
    acuuracyLoader,
    accuracyPercent,
    heatmapLoader,
    highseverityCardLoader,
    highseverityCardData,
    maxValue,
    filters,
    HighestNonComplianceArea,
    highestAlertModule,
    highestAlertOwner,
}) => {

    return (
        <>
            <Col md='6' xs='12'>
                <NewCameraCount filters={filters} loader={connectivityFactoryLoader} data={factoryCamerasCount} />
            </Col>

            <Col md='6' xs='12'>
                <NewAIAccuracy filters={filters} loader={acuuracyLoader} data={accuracyPercent} />
            </Col>
            <Col md='12' lg='6'  >
                <HighestOrHighSeverity
                    filters={filters}
                    heading={'Highest SBO by Module'}
                    highestboolean={true}
                    area={highseverityCardData?.max_alerts?.area}
                    subarea={highseverityCardData?.max_alerts?.sub_area}
                    owner={highseverityCardData?.max_alerts?.area_owner}
                    loader={heatmapLoader}
                    shift={highseverityCardData?.max_alerts?.shift_name}
                    alert={highseverityCardData?.max_alerts?.alert_count}
                    HighestNonComplianceArea={HighestNonComplianceArea}
                    highestAlertModule={highestAlertModule}
                    highestAlertOwner={highestAlertOwner}
                    maxValue={maxValue}
                />
            </Col>
            <Col md='12' lg='6'  >
                <HighestOrHighSeverity
                    filters={filters}
                    highestboolean={false}
                    loader={heatmapLoader}
                    data={highseverityCardData?.highSeverity}
                    heading={'Highest SBO by Module'}
                    area={highseverityCardData?.highSeverity?.area}
                    subarea={highseverityCardData?.highSeverity?.sub_area}
                    owner={highseverityCardData?.highSeverity?.area_owner}
                    alert={highseverityCardData?.highSeverity?.alert_count}
                    shift={highseverityCardData?.highSeverity?.shift_name}
                    HighestNonComplianceArea={HighestNonComplianceArea}
                    highestAlertModule={highestAlertModule}
                    highestAlertOwner={highestAlertOwner}
                    maxValue={maxValue}
                />
            </Col>

        </>
    );
}

export default HeroSection;
